import axios from '@/api/config'

const agentInfo = {
  getAgentInfoById (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfo/` + data, {})
  },
  getAgentInfo (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfo`, {params: data})
  },
  getAgentInfoList (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfoList`, {params: data})
  },
  getAgentInfoTree (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfoTree`, {params: data})
  },
  getAgentRoleInfoList (data) {
    return axios.get(`${process.env.BASE_URL}/agentRoleInfo/getAgentRoleInfoList`, {params: data})
  },
  pageList (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/pageList`, data)
  },
  addAgentInfo (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/addAgentInfo`, data)
  },
  updateAgentInfo (data) {
    return axios.put(`${process.env.BASE_URL}/agentInfo/updateAgentInfo`, data)
  },
  deleteAgentInfo (data) {
    return axios.delete(`${process.env.BASE_URL}/agentInfo/deleteAgentInfo`, {data: data})
  },
  exportExcel (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/exportExcel`, {params: data})
  },
  getAgentInfoRechargeStats (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfoRechargeStats`, {params: data})
  },
  importData (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/importData`, data)
  },
  addAgentAmountLog (data) {
    return axios.post(`${process.env.BASE_URL}/agentAmountLog/addAgentAmountLog`, data)
  },
  enabledAgentInfo (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/enabledAgentInfo`, data)
  },
  distributionStatisticsPageList (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/distributionStatisticsPageList`, data)
  },
  getOrderCountAndCommissionOnTurnover (data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getOrderCountAndCommissionOnTurnover`, {params: data})
  },
  distributionGoodsInfoPageList (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/distributionGoodsInfoPageList`, data)
  },
  distributionPurchasePageList (data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/distributionPurchasePageList`, data)
  },
  getAgentDomain (data) {
    return axios.get(`${process.env.BASE_URL}/generalSetting/getDomain`, {params: data})
  },
  updateAgentDomain (data) {
    return axios.put(`${process.env.BASE_URL}/generalSetting/updateDomain`, data)
  },
  addCapacityLog (data) {
    return axios.post(`${process.env.BASE_URL}/agentAmountLog/addCapacityLog`, data)
  },
}

export default agentInfo



// WEBPACK FOOTER //
// ./src/api/agentInfo.js